/* eslint-disable max-len */
import React from 'react';

const ReadIcon = () =>
  <svg width="16px" height="16px" viewBox="0 0 16 16">
    <path stroke="none" fill="#FFFFFF" d="M2,3.5 L0.5,3.5 L0.5,14 C0.5,14.825 1.175,15.5 2,15.5 L12.5,15.5 L12.5,14 L2,14 L2,3.5 L2,3.5 Z M14,0.5 L5,0.5 C4.175,0.5 3.5,1.175 3.5,2 L3.5,11 C3.5,11.825 4.175,12.5 5,12.5 L14,12.5 C14.825,12.5 15.5,11.825 15.5,11 L15.5,2 C15.5,1.175 14.825,0.5 14,0.5 L14,0.5 Z M13.25,7.25 L5.75,7.25 L5.75,5.75 L13.25,5.75 L13.25,7.25 L13.25,7.25 Z M10.25,10.25 L5.75,10.25 L5.75,8.75 L10.25,8.75 L10.25,10.25 L10.25,10.25 Z M13.25,4.25 L5.75,4.25 L5.75,2.75 L13.25,2.75 L13.25,4.25 L13.25,4.25 Z" />
  </svg>;

export default ReadIcon;



// WEBPACK FOOTER //
// ./src/components/FooterLinks/ReadIcon.js


// WEBPACK FOOTER //
// webpack:///src/components/FooterLinks/ReadIcon.js